import MQTT from '@tigerbrokers/mqtt-pipe'
import getDeviceId from 'utils/getDeviceId'
import getEnv from 'utils/getEnv'

const deviceId = getDeviceId()
const envType = getEnv() === 'production' ? 'prod' : 'dev'

const MQTT_PROD_URL = 'wss://live.tradeup.com:8885/mqtt'

const mqtt = new MQTT({
  url: envType === 'prod' ? MQTT_PROD_URL : '',
  test: envType === 'dev',
  deviceId,
  reconnectPeriod: 10 * 1000
})

export function mqttSub(id, topic) {
  if (mqtt.subscribe) mqtt.sub(id, topic)
}

export function mqttUnsub(id, topic) {
  if (mqtt.unsubscribe) mqtt.unsub(id, topic)
}

export default mqtt
